module.exports = __webpack_public_path__ + "media/public/images/error/paintings-73db19f3e3f6ad3f00f6bf4bc6275d16.jpg";